import axios from 'axios';
import Metadata from '../helpers/metadata/Metadata';
import recordDescriptorProcessing from '../helpers/StoreFunctions/recordDescriptorProcessing';
import serviceUtil from './serviceUtil';

let helpers = {
  getUnreadAnnouncements(options){
    let url = `${process.env.REACT_APP_API}/announcements/unread_for_user?current_company=${localStorage.current_company_id}`;
    if (options && options.recordDescriptor) {
      url += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    return axios({
      method: 'get',
      url,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  getAnnouncement(announcement_id, options) {
    let url = `${process.env.REACT_APP_API}/announcements/${announcement_id}?current_company=${localStorage.current_company_id}`;
    if (options && options.recordDescriptor) {
      url += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    return axios({
      method: 'get',
      url,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        if (options) {
          return response.data;
        }
        else {
          return response.data.team;
        }
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  markAnnouncementRead(announcementId, eventMetadatum, options) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    let url = `${process.env.REACT_APP_API}/announcements/${announcementId}/mark_read?current_company=${localStorage.current_company_id}`;
    if (options && options.recordDescriptor) {
      url += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    return axios({
      method: 'patch',
      url: url,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
      data: {
        event_metadatum: eventMetadatum,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
};

export default helpers;



// WEBPACK FOOTER //
// ./src/services/announcementsService.js